const Footer = () => {
    return (
        <footer>
            <ul className="bottom-menu">
                <li>
                    <a href="/">ホーム</a>
                </li>
                <li>
                    <a href="/shop-list">店舗</a>
                </li>
                <li>
                    <a href="/map">MAP</a>
                </li>
                <li>
                    <a href="/information">総合案内</a>
                </li>
            </ul>
        </footer>
    );
};

export default Footer;
